import React from "react";
import ItemContainer from "./old-container";
import ItemModalContainer from "features/item/containers/ItemModalContainer";
import { useHistory } from "react-router-dom";

//TODO: remove the page interaction from the item container, use only item detail modal for page interaction,
//also remove it from the routes and browser history file

const Item = (props) => {
  const router = useHistory();
  return props?.type?.toLowerCase() === "modal" ||
    router?.location?.state?.type?.toLowerCase() === "modal" ? (
    <ItemModalContainer {...props} type="page" isDineIn={true} />
  ) : (
    <ItemContainer {...props} isDineIn={true} />
  );
};

export default Item;
